module.exports = __webpack_public_path__ + "assets/img/my.24aaffd1.png";